module.exports = __webpack_public_path__ + "img/sliding_bay.d219fbe.svg";